export const AUTH_FLOW_PURPOSE_KEY = "auth_flow_purpose";
export const AUTH_FLOW_PURPOSE_PASSWORD_RESET = "PASSWORD_RESET";
export const AUTH_FLOW_PURPOSE_RESET_TOTP = "RESET_TOTP";
export const AUTH_FLOW_PURPOSE_LOGIN = "LOGIN";
export const AUTH_FLOW_PURPOSE_CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const AUTH_FLOW_PURPOSE_CHANGE_OTP_PREFERENCE = "CHANGE_OTP_PREFERENCE";
